import { render, staticRenderFns } from "./TopUp.vue?vue&type=template&id=00fece40&scoped=true&"
import script from "./TopUp.vue?vue&type=script&lang=js&"
export * from "./TopUp.vue?vue&type=script&lang=js&"
import style0 from "styles/views/account/balance.css?vue&type=style&index=0&id=00fece40&scoped=true&lang=css&"
import style1 from "./TopUp.vue?vue&type=style&index=1&id=00fece40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fece40",
  null
  
)

export default component.exports